import { useState, useEffect } from "react";
import { X, AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSiteSettings } from "@/contexts/SiteSettingsContext";

const EmergencyBanner = () => {
  const { settings } = useSiteSettings();
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem("emergency_banner_dismissed");
    if (dismissed) setIsDismissed(true);
  }, []);

  const message = settings?.global_emergency_message;

  const handleDismiss = () => {
    setIsDismissed(true);
    localStorage.setItem("emergency_banner_dismissed", "true");
  };

  if (!message || isDismissed) return null;

  return (
    <div className="bg-destructive text-destructive-foreground">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3 flex-1">
            <AlertTriangle className="h-5 w-5 flex-shrink-0" />
            <p className="text-sm font-medium whitespace-pre-line">{message}</p>
          </div>
          <Button variant="ghost" size="icon" className="h-8 w-8 flex-shrink-0 hover:bg-destructive-foreground/10"
            onClick={handleDismiss} aria-label="Dismiss banner">
            <X className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EmergencyBanner;
